/* eslint-disable camelcase */
import { FC } from 'react'
import {
  BooleanInput, Create, SimpleForm, TextInput, required,
} from 'react-admin'
import { useLocation } from 'react-router-dom'
import { useFormContext } from 'react-hook-form'
import { OrganizationUserCreate as OrganizationUserCreateType } from '../../types/apiRequests'
import { LocationStateWithOrg } from '../../types/localTypes'
import Auth0UserAutocomplete from '../../components/Auth0UserAutocomplete'

const Auth0UserField: FC = () => {
  const { setValue } = useFormContext<OrganizationUserCreateType>()

  return (
    <Auth0UserAutocomplete
      onSelect={(user) => {
        if (user) {
          setValue('username', user.name || user.email || '', { shouldDirty: true })
          setValue('display_name', user.name || '', { shouldDirty: true })
          setValue('auth0_email', user.email || '', { shouldDirty: true })
        }
      }}
    />
  )
}

const OrganizationUserCreate: FC = () => {
  const location = useLocation()
  const state = location.state as LocationStateWithOrg | undefined
  const orgId = state?.organization_id || ''

  const transform = (data: OrganizationUserCreateType): OrganizationUserCreateType => ({
    ...data,
    organization_id: data.organization_id || orgId,
  })

  const defaultValues: Partial<OrganizationUserCreateType> = {
    organization_id: orgId,
    enabled: true,
  }

  return (
    <Create
      transform={transform}
      redirect={orgId ? `/organization/${orgId}/show/users` : 'list'}
    >
      <SimpleForm defaultValues={defaultValues}>
        <TextInput source="organization_id" label="data.organizationId" fullWidth validate={required()} disabled={!!orgId} />
        <Auth0UserField />
        <TextInput source="username" label="data.username" fullWidth validate={required()} />
        <TextInput source="display_name" label="data.displayName" fullWidth validate={required()} />
        <TextInput source="auth0_email" label="data.auth0Email" fullWidth validate={required()} type="email" />
        <TextInput source="description" label="data.description" fullWidth />
        <BooleanInput source="enabled" label="data.enabled" defaultValue={true} />
      </SimpleForm>
    </Create>
  )
}

export default OrganizationUserCreate
